import React from 'react';
import { Chip as MaterialUIChip, ChipTypeMap, withStyles } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

const chipStyles = {
  root: {
    '& span': {
      whiteSpace: 'initial',
      padding: '8px',
    },
  },
};

const Chip = (props: Parameters<OverridableComponent<ChipTypeMap<{}, 'div'>>>[0]): JSX.Element => (
  <div
    style={{
      display: 'inline-block',
      backgroundColor: '#fff',
      marginRight: 8,
      marginBottom: 8,
      borderRadius: 16,
      overflow: 'hidden',
    }}
  >
    <MaterialUIChip variant="outlined" {...props} />
  </div>
);

export default withStyles(chipStyles)(Chip);
